
import OpenServiceDeskApi from '@/api/OpenServiceDeskApi';
import router from '@/router';
import { AccountModule } from '@/store/modules/account.module';
import { isEmpty } from '@/utils/tool.util';
import { EllipsisOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue';
import { defineComponent, inject, nextTick, onMounted, ref, toRef } from 'vue';

export default defineComponent({
  components: {
    EllipsisOutlined
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }, // 数据列表
    showOperation: {
      type: Boolean,
      default: true
    }
  },
  setup (props, { emit }) {
    const hasAnyPermissions = inject('hasAnyPermissions')
    const hasPermission = inject('hasPermission')
    const selectedId: any = inject('selectedId')
    const changeSelectedId: any = inject('changeSelectedId')
    const data = toRef(props, 'data')
    const iptRef = ref()

    function handleSelect () {
      changeSelectedId(data.value.id)
    }

    function handleAdd () {
      data.value.active = true
      const firtChild = data.value.children[0]
      if (!firtChild || firtChild.id > 0) {
        data.value.children = [
          {
            name: '',
            parentId: data.value.id,
            id: -1,
            engineerCount: 0,
            children: []
          },
          ...data.value.children
        ]
      }
    }

    function handleEdit () {
      router.push({
        path: '/system_setting/edit-group',
        query: {
          id: props.data.id,
          parentId: props.data.parentId
        }
      });
    }

    function handleDelete () {
      if (confirm('您确定要删除' + data.value.name + '及其子部门吗？')) {
        OpenServiceDeskApi.deleteById({
          id: data.value.id
        }).then(result => {
          if (result) {
            // AccountModule.loadServiceDeskList()
            console.log('-----data.value.id', data.value.id);
            AccountModule.deleteServiceDeskById(data.value.id)
            message.success('删除成功')
          }
        })
      }
    }

    function handleBlur () {
      if (data.value.name) {
        OpenServiceDeskApi.saveOrUpdate({
          inviteEngineers: [],
          serviceDesk: {
            parentId: data.value.parentId,
            name: data.value.name,
            engineers: [],
            jointServiceDesks: []
          }
        }).then(id => {
          data.value.id = id
          message.success('创建成功')
          AccountModule.loadServiceDeskList({ serviceDeskStatus: "0,1" })
        })
        return
      }
      emit('deleteFirst')
    }

    function handleEnter () {
      iptRef.value && iptRef.value.blur()
    }

    function handleUp () {
      //
    }

    function handleDown () {
      //
    }

    onMounted(() => {
      nextTick(() => {
        iptRef.value && iptRef.value.focus()
      })
    })

    return {
      iptRef,
      selectedId,
      hasAnyPermissions,
      hasPermission,
      isEmpty,
      handleSelect,
      handleAdd,
      handleEdit,
      handleDelete,
      handleBlur,
      handleEnter,
      handleUp,
      handleDown
    }
  }
})
